import {LoadingSpinner} from "../custom-components/Spinner.tsx";
import {FC, ReactNode} from "react";

export const IsLoadingContainer: FC<{ isLoading: boolean, children: ReactNode }> = ({isLoading, children}) => {


    return (
        <>
            {
                isLoading
                    ? <LoadingSpinner/>
                    : children
            }
        </>

    )
}